import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { getEthernetVenues } from "../services/apiServices";

const VenueDataContext = createContext({
  venues: {},
  loading: true,
  error: null,
  refetch: () => {},
});

/** Module store so sync helpers (getVenueDataFromVenueId) share the one fetch. */
let venueCatalog = {};

export const getVenueCatalog = () => venueCatalog;

export const setVenueCatalog = (catalog) => {
  venueCatalog = catalog && typeof catalog === "object" ? catalog : {};
};

export const VenueDataProvider = ({ children }) => {
  const [venues, setVenues] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadVenues = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getEthernetVenues();
      const catalog = response?.data && typeof response.data === "object"
        ? response.data
        : {};
      setVenueCatalog(catalog);
      setVenues(catalog);
      if (Object.keys(catalog).length === 0) {
        setError("No venues available. Please try again.");
      }
    } catch (err) {
      console.error("Failed to load ethernet venues:", err);
      setVenueCatalog({});
      setVenues({});
      setError("Unable to load venues. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadVenues();
  }, [loadVenues]);

  const value = useMemo(
    () => ({
      venues,
      loading,
      error,
      refetch: loadVenues,
    }),
    [venues, loading, error, loadVenues],
  );

  return (
    <VenueDataContext.Provider value={value}>
      {children}
    </VenueDataContext.Provider>
  );
};

export const useVenueData = () => useContext(VenueDataContext);
